import styled from 'styled-components'

export const ModalWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(35, 39, 42, 0.85);
	z-index: 1000;
	backdrop-filter: blur(4px);
`

export const ModalContent = styled.div`
	padding: 50px 100px;
	max-width: 570px;
	width: 100%;
	height: fit-content;
	background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
	border-radius: 20px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow: 0px 20px 50px rgba(0, 0, 0, 0.5);
`
